import { type Ref, type RefObject, useEffect, useRef } from 'react';

export const useAutoFocus = (
  autoFocus: boolean | undefined,
  ref?: Ref<HTMLInputElement>,
) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const currentRef: RefObject<HTMLInputElement> =
    ref && 'current' in ref ? ref : inputRef;

  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        // set input autofocus asynchronously to avoid timing issues with modal dialogs utilising FocusTrap
        currentRef.current?.focus();
      }, 100);
    }
  }, [autoFocus, currentRef]);

  return currentRef;
};
